module.exports = __webpack_public_path__ + "img/ill2.081a96d5.svg";